import React, { FC } from 'react';
import TargetService from 'services/TargetService/target.service';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import styles from './deleteModal.module.scss';

interface DeleteLocationModalProps {
  isModalOpen: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  targetId?: number;
  fetchSbtiTargets?:() => Promise<void>
}

const DeleteTargetModal: FC<DeleteLocationModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  targetId,
  fetchSbtiTargets
}) => {
  const { loading, deleteTarget } = TargetService();
  const handleClose = () => setIsModalOpen?.(false);

  const handleDelete = async () => {
    targetId && await deleteTarget(targetId);
    setIsModalOpen?.(false);
    await fetchSbtiTargets?.()
  };

  return (
    <div>
      <OrganizationModal
        visible={isModalOpen}
        onClose={handleClose}
        children={
          <div className={styles.deleteModalContainer}>
            <div className={styles.deleteTitleTextContainer}>
              Are you sure you want to delete this target?
            </div>
            <div className={styles.buttonContainer}>
              <COButton
                danger
                loading={loading}
                children="Delete"
                onClick={handleDelete}
              />
              <COButton secondary children="Cancel" onClick={handleClose} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default DeleteTargetModal;
